import { Button, Card, CardContent, Stack } from "@mui/material";
import { RootPaths } from "@src/appV2/App/paths";
import { APP_V2_USER_EVENTS, logEvent } from "@src/appV2/lib/analytics";
import { generatePath, useHistory, useRouteMatch } from "react-router-dom";

import { type ShiftBlockWithMappedDetails } from "../api/useFetchPaginatedShiftBlocks";
import { SHIFT_BLOCKS_PATH } from "../paths";
import { SHIFT_BLOCK_ACTIONS } from "../utils";
import { ShiftBlockFacilityDetails } from "./ShiftBlockFacilityDetails";
import { ShiftBlockHeader } from "./ShiftBlockHeader";

interface ShiftBlockItemProps {
  shiftBlock: ShiftBlockWithMappedDetails;
  agentTimezone: string;
  shouldShowFacilityDetails: boolean;
}

export function ShiftBlockItem(props: ShiftBlockItemProps) {
  const { shiftBlock, agentTimezone, shouldShowFacilityDetails } = props;
  const history = useHistory();
  const { path: currentRouterUrl } = useRouteMatch();
  const { id: shiftBlockId, facility, isShiftBlockAssigned } = shiftBlock;

  return (
    <Card variant="outlined">
      <CardContent>
        <Stack spacing={2}>
          <ShiftBlockHeader shiftBlockWithDetails={shiftBlock} agentTimezone={agentTimezone} />

          <Stack spacing={2}>
            {shouldShowFacilityDetails && (
              <ShiftBlockFacilityDetails
                facility={facility}
                isShiftBlockAssigned={isShiftBlockAssigned}
              />
            )}

            <Button
              variant="contained"
              onClick={() => {
                logEvent(APP_V2_USER_EVENTS.SHIFT_BLOCKS, {
                  action: SHIFT_BLOCK_ACTIONS.VIEW_BLOCK_DETAILS_TAPPED,
                  shiftBlockId,
                  location: currentRouterUrl,
                });
                history.push(
                  generatePath(`${RootPaths.APP_V2_HOME}/${SHIFT_BLOCKS_PATH}/:shiftBlockId`, {
                    shiftBlockId,
                  })
                );
              }}
            >
              View Block Details
            </Button>
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
}
